(function () {
  'use strict';

  var locale = (document.documentElement.lang || '').toLowerCase();
  var language = locale.split('-')[0];
  var translations = {
    fr: {
      exact: {
        'You May Also Like': 'Vous aimerez aussi',
        'Add items to start earning rewards': 'Ajoutez des articles pour commencer à gagner des récompenses',
        'Free Shipping': 'Livraison gratuite',
        'SMALL SHOPPING BAG': 'PETIT SAC DE SHOPPING',
        'LARGE SHOPPING BAG': 'GRAND SAC DE SHOPPING',
        'Add': 'Ajouter',
        'Close': 'Fermer',
        'Accessory': 'Accessoire'
      },
      buy: function (amount) { return 'Achetez pour ' + amount; }
    },
    de: {
      exact: {
        'You May Also Like': 'Das könnte Ihnen auch gefallen',
        'Add items to start earning rewards': 'Fügen Sie Artikel hinzu, um Prämien zu erhalten',
        'Free Shipping': 'Kostenloser Versand',
        'SMALL SHOPPING BAG': 'KLEINE EINKAUFSTASCHE',
        'LARGE SHOPPING BAG': 'GROSSE EINKAUFSTASCHE',
        'Add': 'Hinzufügen',
        'Close': 'Schließen',
        'Accessory': 'Zubehör'
      },
      buy: function (amount) { return 'Kaufen Sie für ' + amount; }
    },
    ja: {
      exact: {
        'You May Also Like': 'おすすめ商品',
        'Add items to start earning rewards': '商品を追加して特典を獲得',
        'Free Shipping': '送料無料',
        'SMALL SHOPPING BAG': 'スモールショッピングバッグ',
        'LARGE SHOPPING BAG': 'ラージショッピングバッグ',
        'Add': '追加'
      },
      buy: function (amount) { return amount + '以上購入'; }
    },
    vi: {
      exact: {
        'You May Also Like': 'Có thể bạn cũng thích',
        'Add items to start earning rewards': 'Thêm sản phẩm để bắt đầu nhận phần thưởng',
        'Free Shipping': 'Miễn phí vận chuyển',
        'SMALL SHOPPING BAG': 'TÚI MUA SẮM CỠ NHỎ',
        'LARGE SHOPPING BAG': 'TÚI MUA SẮM CỠ LỚN',
        'Add': 'Thêm'
      },
      buy: function (amount) { return 'Mua từ ' + amount; }
    },
    es: {
      exact: {
        'You May Also Like': 'También te puede gustar',
        'Add items to start earning rewards': 'Añade productos para empezar a obtener recompensas',
        'Free Shipping': 'Envío gratis',
        'SMALL SHOPPING BAG': 'BOLSA DE COMPRA PEQUEÑA',
        'LARGE SHOPPING BAG': 'BOLSA DE COMPRA GRANDE',
        'Add': 'Añadir'
      },
      buy: function (amount) { return 'Compra por ' + amount; }
    }
  };

  var dictionary = translations[language];
  if (!dictionary) return;

  function translateTextNode(node) {
    if (node.parentElement && node.parentElement.closest('script, style, noscript, textarea')) return;
    var original = node.nodeValue;
    var trimmed = original.trim();
    if (!trimmed) return;

    var translated = dictionary.exact[trimmed];
    if (!translated) {
      var buyMatch = trimmed.match(/^Buy\s+(.+)$/i);
      if (buyMatch) translated = dictionary.buy(buyMatch[1]);
    }
    if (!translated || translated === trimmed) return;

    node.nodeValue = original.replace(trimmed, translated);
  }

  function translateRoot(root) {
    if (!root || !root.querySelectorAll) return;

    var walker = document.createTreeWalker(root, NodeFilter.SHOW_TEXT);
    var textNode;
    while ((textNode = walker.nextNode())) translateTextNode(textNode);

    var elements = root.querySelectorAll('*');
    for (var i = 0; i < elements.length; i += 1) {
      if (elements[i].shadowRoot) translateRoot(elements[i].shadowRoot);
    }
  }

  function run() { translateRoot(document.body); }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', run, { once: true });
  } else {
    run();
  }

  new MutationObserver(function (mutations) {
    for (var i = 0; i < mutations.length; i += 1) {
      var mutation = mutations[i];
      if (mutation.type === 'characterData') {
        translateTextNode(mutation.target);
      } else {
        for (var j = 0; j < mutation.addedNodes.length; j += 1) {
          var added = mutation.addedNodes[j];
          if (added.nodeType === Node.TEXT_NODE) translateTextNode(added);
          if (added.nodeType === Node.ELEMENT_NODE) translateRoot(added);
        }
      }
    }
  }).observe(document.documentElement, {
    childList: true,
    subtree: true,
    characterData: true
  });

  /* Some app widgets attach shadow roots after their host enters the DOM. */
  var checks = 0;
  var timer = window.setInterval(function () {
    run();
    checks += 1;
    if (checks >= 20) window.clearInterval(timer);
  }, 1000);
})();
